import { Trans } from '~/common/context';
import { Button, Card, Flex, Icon, Spinner, Text } from '@wyz/ui';
import { Link } from 'react-router';
import { useManageQuoteCart } from '~/purchase/api';

function QuoteCartStatus() {
  const cart = useManageQuoteCart({ get: { enabled: true } });
  const isCartFetched = cart.get.isSuccess && cart.get.isFetched;

  return (
    <Flex className='space-x-1'>
      <Card className='rounded-1'>
        <Card.Body className='py-0 px-1 fw-semi-bold'>
          <div className='fs-xxs'>
            <Trans i18nKey='app.purchase.quote_cart_page.in_your_quote' />
          </div>
          {isCartFetched && cart.get.data?.data.items.length ? (
            <>
              <Text color='secondary' heading='xs' id='cart-items-count'>
                <Trans
                  i18nKey='app.purchase.cart_count'
                  values={{
                    referenceCount: cart.get.data.data.referenceCount,
                    productCount: cart.get.data.data.productCount,
                  }}
                />
              </Text>
            </>
          ) : cart.get.isProcessing ? undefined : (
            <div className='fs-xs text-title-color' data-cy='cart-items-count'>
              <Trans i18nKey='app.purchase.empty_cart' />
            </div>
          )}
        </Card.Body>
      </Card>
      <Button
        id='check-quote-cart'
        variant='primary'
        size='md'
        as={Link}
        to='cart'
      >
        {cart.get.isProcessing ? (
          <Spinner style={{ width: 20, height: 20 }} />
        ) : (
          <div className='position-relative'>
            <Icon icon='clip-board' size='xs' />
            {Boolean(cart.get.data?.data.items.length) && (
              <div
                className='position-absolute bg-blue-secondary rounded-circle'
                style={{
                  left: '100%',
                  top: 0,
                  width: '0.475rem',
                  height: '0.475rem',
                }}
              ></div>
            )}
          </div>
        )}
      </Button>
    </Flex>
  );
}

export default QuoteCartStatus;
